import { useCallback } from 'react';

import { usePico } from '../pico';

export type ColdStorageUxSurface =
  | 'homepage'
  | 'library'
  | 'svv'
  | 'folder_review'
  | 'showcase'
  | 'intro_modal';

export type ColdStorageUxClickElement =
  | 'quota_meter_lock'
  | 'homepage_hero_upgrade_button'
  | 'homepage_hero_delete_videos_button'
  | 'locked_video'
  | 'locked_video_menu_upgrade'
  | 'locked_video_menu_share'
  | 'locked_video_menu_delete'
  | 'locked_video_page_upgrade_button'
  | 'learn_more'
  | 'upgrade_button'
  | 'view_videos'
  | 'intro_modal_restore'
  | 'intro_modal_dismiss';

export const useColdStorageTracking = () => {
  const pico = usePico();

  const trackColdStorageUxDisplayed = useCallback(
    ({ surface }: { surface: ColdStorageUxSurface }) => {
      if (pico === null) {
        return;
      }
      pico.track('cold_storage_ux_displayed', {
        surface,
      });
    },
    [pico],
  );

  const trackColdStorageUxClicked = useCallback(
    ({ element }: { element: ColdStorageUxClickElement }) => {
      if (pico === null) {
        return;
      }
      pico.track('cold_storage_ux_clicked', {
        element,
      });
    },
    [pico],
  );

  const trackColdStorageUxDeletedVideo = useCallback(() => {
    if (pico === null) {
      return;
    }
    pico.track('cold_storage_ux_deleted_video', {});
  }, [pico]);

  return {
    trackColdStorageUxDisplayed,
    trackColdStorageUxClicked,
    trackColdStorageUxDeletedVideo,
  };
};
